import { IProductCategory } from 'interfaces/product-category';
import create from 'zustand';
interface ProductCategoryStoreState {
  productCategories: IProductCategory[];
  productCategoriesTree: IProductCategory[];
  setProductCategories: (productCategories: IProductCategory[]) => void;
  setProductCategoriesTree: (productCategoriesTree: IProductCategory[]) => void;
}

export const useProductCategoryStore = create<ProductCategoryStoreState>(
  (set) => ({
    productCategories: [],
    productCategoriesTree: [],
    setProductCategories: (payload) =>
      set(() => ({ productCategories: payload })),
    setProductCategoriesTree: (payload) =>
      set({ productCategoriesTree: payload }),
  })
);
